import { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';

// Graco dependencies
import OrgBilling from './OrgBilling/OrgBilling.jsx';
import OrgFluids from './OrgFluids/OrgFluids.jsx';
import OrgDetails from './OrgDetails/OrgDetails.jsx';
import OrgManage from './OrgManage/OrgManage.jsx';
import OrgNav from './OrgNav/OrgNav.jsx';
import OrgCreate from './OrgCreate/OrgCreate.jsx';
import OrgTemplates from './OrgTemplates/OrgTemplates';
import OrgNoAccess from './OrgNoAccess/OrgNoAccess.jsx';
import BranchCreate from './BranchCreate/BranchCreate.jsx';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// Page routing for org management specific pages
const PageRouter = (props) => {
  let data = useLocation();
  return (
    <Switch>
      {data.state
        ?
        <Route exact path='/orgs/new'> <OrgCreate firstOrg={props.orgInfo.orgId === "" ? true : false} orgInfo={data.state.orgInfo} orgEdit={data.state.orgEdit} /></Route>
        :
        <Route exact path='/orgs/new'> <OrgCreate firstOrg={props.orgInfo.orgId === "" ? true : false} orgInfo={props.orgInfo} orgEdit={false} /></Route>
      }

      <Route exact path='/orgs/:orgName/templates'> <OrgTemplates orgInfo={props.orgInfo} /></Route>
      <Route exact path='/orgs/:orgName/billing'> <OrgBilling orgInfo={props.orgInfo} /></Route>
      <Route exact path='/orgs/:orgName/fluids'> <OrgFluids orgInfo={props.orgInfo} /></Route>
      <Route exact path='/orgs/:orgName/details'> <OrgDetails orgInfo={props.orgInfo} /></Route>
      <Route exact path='/orgs/:orgName/manage'> <OrgManage orgInfo={props.orgInfo} fetchOrgInformation={props.fetchOrgInformation} /></Route>
      <Route exact path='/orgs/:orgName/branches'> <BranchCreate orgInfo={props.orgInfo} firstBranch={false} /></Route>

      <Route path='/orgs'> <OrgNav orgInfo={props.orgInfo} /></Route>
    </Switch>
  );
}

// Org page component checks for editor privileges and routes to the appropriate page
export default function OrgPage({ orgInfo, fetchOrgInformation }) {
  return (
    <Fragment>
      {orgInfo.isOrgEditor ? <PageRouter orgInfo={orgInfo} fetchOrgInformation={fetchOrgInformation} s /> : <OrgNoAccess />}
    </Fragment>
  )
}
